import { Ingredient } from './ingredients'

export type Potion =
  | 'animalWhispers'
  | 'dreams'
  | 'friendship'
  | 'glow'
  | 'health'
  | 'love'
  | 'luck'
  | 'secrets'
  | 'shadows'

export type PotionRecipe = {
  name: Potion
  ingredients: Array<Ingredient>
  found: boolean
}

export const potions: Array<PotionRecipe> = [
  {
    name: 'animalWhispers',
    ingredients: ['frog', 'honey', 'mushroom'],
    found: false
  },
  {
    name: 'dreams',
    ingredients: ['frog', 'ghostpipe', 'moonwater'],
    found: false
  },
  {
    name: 'friendship',
    ingredients: ['honey', 'mushroom', 'waterlily'],
    found: false
  },
  {
    name: 'glow',
    ingredients: ['ghostpipe', 'moonwater', 'waterlily'],
    found: false
  },
  {
    name: 'health',
    ingredients: ['honey', 'moonwater', 'mushroom'],
    found: false
  },
  {
    name: 'love',
    ingredients: ['honey', 'rose', 'waterlily'],
    found: false
  },
  {
    name: 'luck',
    ingredients: ['frog', 'mushroom', 'rose'],
    found: false
  },
  {
    name: 'secrets',
    ingredients: ['frog', 'ghostpipe', 'rose'],
    found: false
  },
  {
    name: 'shadows',
    ingredients: ['ghostpipe', 'moonwater', 'rose'],
    found: false
  }
]
